// pages/ProductsPage.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js';
import { useModal } from '../context/ModalContext.js';
import API from '../api/MainApi.js';
import constants from '../config/consts.js';
import './ProductsPage.css';

const ProductsPage = () => {
    const { hasPermission } = useAuth();
    const { showConfirm, showAlert } = useModal();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState('all');

    useEffect(() => {
        loadProducts();
    }, [filter]);

    const loadProducts = async () => {
        setLoading(true);
        try {
            const status = filter !== 'all' ? filter : '';
            const data = await API.getProducts(status);
            setProducts(data.data);
        } catch (error) {
            showAlert('Ошибка', 'Не удалось загрузить товары', 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id, title) => {
        showConfirm(
            'Удаление товара',
            `Вы уверены, что хотите удалить товар "${title}"?`,
            async () => {
                try {
                    await API.deleteProduct(id);
                    showAlert('Успешно', 'Товар успешно удален', 'success');
                    await loadProducts();
                } catch (error) {
                    showAlert('Ошибка', 'Не удалось удалить товар', 'error');
                }
            }
        );
    };

    const handleStatusChange = async (id, currentStatus, title) => {
        const newStatus = currentStatus === 'active' ? 'archive' : 'active';
        const action = newStatus === 'active' ? 'активировать' : 'отправить в архив';
        
        showConfirm(
            'Изменение статуса',
            `Вы уверены, что хотите ${action} товар "${title}"?`,
            async () => {
                try {
                    await API.updateProductStatus(id, newStatus);
                    showAlert('Успешно', `Статус товара изменен на ${newStatus === 'active' ? 'активный' : 'в архиве'}`, 'success');
                    await loadProducts();
                } catch (error) {
                    showAlert('Ошибка', 'Не удалось изменить статус', 'error');
                }
            }
        );
    };

    if (loading) return <div className="loading">Загрузка...</div>;

    return (
        <div className="products-page">
            <div className="page-header">
                <h1>Управление товарами</h1>
                <div className="header-actions">
                    <select 
                        value={filter} 
                        onChange={(e) => setFilter(e.target.value)}
                        className="filter-select"
                    >
                        <option value="all">Все товары</option>
                        <option value="active">Активные</option>
                        <option value="archive">В архиве</option>
                    </select>
                    
                    {hasPermission('canManageProducts') && (
                        <Link to="/products/create" className="btn btn-primary">
                            Добавить товар
                        </Link>
                    )}
                </div>
            </div>

            {products.length === 0 ? (
                <div className="no-products">
                    <h2>Товары не найдены</h2>
                    <p>Добавьте первый товар</p>
                    {hasPermission('canManageProducts') && (
                        <Link to="/products/create" className="btn btn-primary">
                            Добавить товар
                        </Link>
                    )}
                </div>
            ) : (
                <div className="products-grid">
                    {products.map(product => (
                        <div key={product._id} className="product-card">
                            {product.images && (
                                <div className="product-image">
                                    <img 
                                        src={`${constants.serverUrl}${product.images?.split(',')[0]}`} 
                                        alt={product.title}
                                    />
                                </div>
                            )}
                            <div className="product-info">
                                <h3>{product.title}</h3>
                                <p className="product-description">{product.description}</p>
                                <div className="product-meta">
                                    <span className="product-price">{product.price} ₽</span>
                                    <span className={`product-status ${product.status}`}>
                                        {product.status === 'active' ? 'Активен' : 'В архиве'}
                                    </span>
                                </div>
                                <div className="product-stats">
                                    <span>👁 {product.views || 0}</span>
                                    <span>📦 {product.orders || 0}</span>
                                </div>
                            </div>
                            <div className="product-actions">
                                <Link to={`/products/edit/${product._id}`} className="btn-edit">
                                    Редактировать
                                </Link>
                                
                                {hasPermission('canChangeProductStatus') && (
                                    <button
                                        onClick={() => handleStatusChange(
                                            product._id, 
                                            product.status,
                                            product.title
                                        )}
                                        className="btn-status"
                                    >
                                        {product.status === 'active' ? 'В архив' : 'Активировать'}
                                    </button>
                                )}
                                
                                {hasPermission('canDeleteProducts') && (
                                    <button
                                        onClick={() => handleDelete(product._id, product.title)}
                                        className="btn-delete"
                                    >
                                        Удалить
                                    </button>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ProductsPage;